/** @format */

import React from 'react'

import {RequireFeature} from '@src/components/tailwind/RequireFeature'

import {useFormApi} from '@src/contexts'

import {ActionBar} from './ActionBar'
import {Menubar} from './Menubar'
import {OverlimitBanner} from './OverlimitBanner'
import {Pagination} from './Pagination'
import {ActiveSearchBar, RequireUpgradeSearchBar} from './SearchBar'
import {
  SubmissionsContextProvider,
  useSubmissionsContext,
} from './SubmissionsContext'
import {Table} from './Table'
import {TableModelProvider} from './TableModel'

export function Submissions() {
  const {current: currentForm} = useFormApi()
  return (
    <SubmissionsContextProvider form={currentForm}>
      <div className="flex min-h-full flex-col gap-y-8 px-2 py-8 sm:px-8">
        <OverlimitBanner />
        <SearchSection />
        <section className="rounded-lg bg-white">
          <TableModelProvider>
            <ActionBar />
            <Menubar />
            <Table />
            <Pagination />
          </TableModelProvider>
        </section>
      </div>
    </SubmissionsContextProvider>
  )
}

function SearchSection() {
  const {current: currentForm} = useFormApi()
  const {filter} = useSubmissionsContext()

  // search is not supported in the Over Limit folder
  if (filter.folder === 'overlimit') {
    return null
  }

  return (
    <section>
      <RequireFeature
        fallback={<RequireUpgradeSearchBar />}
        feature="search_submissions"
        on={currentForm}
      >
        <ActiveSearchBar />
      </RequireFeature>
    </section>
  )
}

export default Submissions
